import Modal from "@/common/components/Modal";
import useModalMessagesSimple from "@/common/hooks/useModalMessagesSimple";
import { useQueryClient } from "@tanstack/react-query";
import { useDeleteDashboard } from "../../hooks/dashboards/useDeleteDashboard";

interface DeleteDashboardProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  dashboardId: string;
  onDeleteDashboard: () => void;
}

const DeleteDashboard = ({
  isOpen,
  setIsOpen,
  dashboardId,
  onDeleteDashboard,
}: DeleteDashboardProps) => {
  const queryClient = useQueryClient();

  const { setMessages } = useModalMessagesSimple({
    isError: true,
  });

  const {
    mutate: deleteDashboardComponent,
    isPending: deleteDashboardComponentIsPending,
  } = useDeleteDashboard({
    dashboardId,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['dashboards'],
        });

        setIsOpen(false);

        onDeleteDashboard();
      },
      onError: (error) => setMessages(error, {
        errorResponse: true,
      }),
    },
  });

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      className="rounded-lg overflow-hidden"
      title="Você tem certeza?"
      subtitle="Essa ação não poderá ser desfeita"
      subtitleClassName="mt-1 text-white-400"
      showClose={false}
      useCancellableFooter
      onConfirm={() => deleteDashboardComponent()}
      confirmButtonIsLoading={deleteDashboardComponentIsPending}
    />
  );
}

export default DeleteDashboard;
